import React from 'react';
import { daysUntil, formatUpcoming } from '../dateOnly';

// "Client Birthdays" dashboard widget: this therapist's active clients with a
// birthday in the next 30 days, soonest first. Fed by GET
// /therapist/client-attention (fetched once by the dashboard). `upcoming` and
// `dob` arrive as 'YYYY-MM-DD' strings and are parsed as local dates so the
// day never shifts across time zones.

export default function ClientBirthdaysCard({ data }) {
  if (!data) return <div style={mutedStyle}>Loading…</div>;
  const birthdays = data.birthdays || [];

  if (birthdays.length === 0) {
    return (
      <div style={{ ...mutedStyle, padding: '10px 4px' }}>
        🎂 No client birthdays in the next 30 days.
      </div>
    );
  }

  return (
    <div>
      {birthdays.map((c) => {
        const days = daysUntil(c.upcoming);
        const isToday = days === 0;
        const soon = days !== null && days < 7;
        return (
          <div
            key={c.id}
            style={{
              ...rowStyle,
              background: isToday ? '#e7f6ec' : 'transparent',
              border: isToday ? '1px solid #bfe5cc' : '1px solid transparent',
              borderBottom: isToday ? '1px solid #bfe5cc' : '1px solid var(--border-color)',
            }}
          >
            <div style={{ ...whenStyle, color: soon ? 'var(--success-color)' : 'var(--text-muted)', fontWeight: soon ? 700 : 600 }}>
              {isToday ? '🎉 Today' : formatUpcoming(c.upcoming)}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <span style={{ fontWeight: 600, color: 'var(--text-strong)' }}>{c.client_name}</span>
              {c.turns ? <span style={{ ...mutedStyle, marginLeft: 6 }}>turns {c.turns}</span> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

const mutedStyle = { color: 'var(--text-muted)', fontSize: 13 };
const rowStyle = {
  display: 'flex', gap: 12, alignItems: 'center',
  borderRadius: 8, padding: '7px 10px', fontSize: 13.5,
};
const whenStyle = { flexShrink: 0, width: 96, fontSize: 12.5 };
